import React from 'react';
import AppFooterContainer from '../../common/components/AppFooter/AppFooterContainer';
import PageContainer from '../../common/components/Page/PageContainer';
import './Unauthorized.css';

const Unauthorized = (props) => {
  return props.asPage != undefined && props.asPage == true ? (
    <PageContainer pageName="not-authorized">
      <div
        className="u-fx u-fx-column u-fx-align-center u-fx-justify-center"
        qaTag="page-not-authorized"
      >
        <p>Ups! 401 Unauthorized.</p>
      </div>
    </PageContainer>
  ) : (
    <div className="page page-not-authorized">
      <div
        className="page__content page-not-authorized__content u-fx u-fx-column u-fx-align-center u-fx-justify-center"
        qaTag="page-not-authorized"
      >
        <p>Ups! 401 Unauthorized.</p>
      </div>
      <AppFooterContainer />
    </div>
  );
};

export default Unauthorized;
